import React, { useState, useEffect } from 'react';
import Modal from 'react-modal'; // Import modal component
import './Blog.css'; // Ensure to create a Blog.css file for styles

// Ensure Modal is properly attached to the root element
Modal.setAppElement('#root');

function Blog() {
    const [articles, setArticles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    // Fetch articles from the JSON file
    useEffect(() => {
        fetch('/articles.json') // Ensure this path is correct
            .then(response => response.json())
            .then(data => {
                console.log(data);  // Log the data to the console
                setArticles(data);
            })
            .catch(error => {
                console.error("Error fetching articles:", error);
            });
    }, []);

    const openModal = (article) => {
        setSelectedArticle(article);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedArticle(null);
    };

    return (
        <div className="blog">
            <h1>Articles</h1>
            <p>
                Stay updated with the latest trends in web development, programming tips, and business insights. Explore our blog to learn more about the ever-evolving world of technology.
            </p>

            <div className="article-grid">
                {articles.map((article) => (
                    <div className="article-card" key={article.id}>
                        <h2>{article.title}</h2>
                        <p className="article-meta">
                            <span>{article.date}</span> | <span>{article.author}</span>
                        </p>
                        <p className="article-summary">{article.summary}</p>
                        <button onClick={() => openModal(article)} className="read-more">Read more</button>
                    </div>
                ))}
            </div>

            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Article Modal"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                {selectedArticle && (
                    <>
                        <h2>{selectedArticle.title}</h2>
                        <p>{selectedArticle.date} | {selectedArticle.author}</p>
                        <div
                            className="article-content"
                            dangerouslySetInnerHTML={{ __html: selectedArticle.content }}
                        />
                        <button onClick={closeModal} className="close-btn">Close</button>
                    </>
                )}
            </Modal>
        </div>
    );
}

export default Blog;
